import { render } from "./AvisoTreinamentoCalendarioVencidoModal.vue?vue&type=template&id=56a91bec&scoped=true"
import script from "./AvisoTreinamentoCalendarioVencidoModal.vue?vue&type=script&lang=js"
export * from "./AvisoTreinamentoCalendarioVencidoModal.vue?vue&type=script&lang=js"

import "./AvisoTreinamentoCalendarioVencidoModal.vue?vue&type=style&index=0&id=56a91bec&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a91bec"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QSeparator,QIcon,QSpinner});
